import { Button, Flex, Typography } from '@iheartjane/reefer';

import type { SsoChannel } from '@jane/kiosk/util';

interface ConfirmationScreenProps {
  error: string | null;
  loginOnKiosk({
    newUser,
    ssoChannel,
  }: {
    newUser: boolean;
    ssoChannel: SsoChannel;
  }): void;
  logoutUser(): void;
  storeName: string;
  userName: string;
}

export const ConfirmationScreen = ({
  error,
  loginOnKiosk,
  logoutUser,
  storeName,
  userName,
}: ConfirmationScreenProps) => {
  return (
    <Flex
      flexDirection="column"
      gap={16}
      alignItems="center"
      justifyContent="center"
      p={24}
      height="100vh"
      width="100vw"
    >
      <Typography variant="h2-semibold" textAlign="center">
        Do you want to continue as {userName} at {storeName}?
      </Typography>
      <Button
        label="Continue to kiosk"
        full
        branded
        size="small"
        onClick={() => loginOnKiosk({ newUser: false, ssoChannel: null })}
      />
      <Button
        label="Use another account"
        full
        branded
        size="small"
        variant="primary-inverse"
        onClick={logoutUser}
      />
      {error && (
        <Typography color="error" mt={12}>
          {typeof error === 'string' ? error : 'There was an error logging in.'}
        </Typography>
      )}
    </Flex>
  );
};
